module.exports = __webpack_public_path__ + "img/pay-fail.9ca35877.png";